import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './NavBar.css';
import { isLoggedIn, clearToken } from '../auth/auth';

function NavBar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  // 토큰 상태 확인
  useEffect(() => {
    const checkLogin = () => setIsUserLoggedIn(isLoggedIn());

    checkLogin();
    window.addEventListener('auth-change', checkLogin);

    return () => {
      window.removeEventListener('auth-change', checkLogin);
    };
  }, []);

  const handleLogout = () => {
    clearToken();
    setIsUserLoggedIn(false);
    navigate('/');
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <header className="navbar">
      <div className="navbar-left">
        <Link to="/" className="nav-button-company-name">STARTUS</Link>
      </div>

      {/* 데스크탑 메뉴 */}
      <nav className={`navbar-right ${isOpen ? 'open' : ''}`}>
        <Link to="/" className="nav-button" onClick={() => setIsOpen(false)}>{t('common.home')}</Link>
        <Link to="/about" className="nav-button" onClick={() => setIsOpen(false)}>{t('common.about')}</Link>
        <Link to="/insights" className="nav-button" onClick={() => setIsOpen(false)}>{t('common.insights')}</Link>
        <Link to="/pricing" className="nav-button" onClick={() => setIsOpen(false)}>{t('pricing.nav_label')}</Link>

        <Link to="/mypage" className="nav-button" onClick={() => setIsOpen(false)}>{t('common.mypage')}</Link>

        {isUserLoggedIn ? (
          <button type="button" className="nav-button" onClick={() => { handleLogout(); setIsOpen(false); }}>
            Logout
          </button>
        ) : (
          <Link to="/login" className="nav-button" onClick={() => setIsOpen(false)}>{t('common.login')}</Link>
        )}

        {/* Language Switcher */}
        <div className="lang-switcher" aria-label="Language">
          <button
            type="button"
            className={`lang-button ${i18n.language === 'ko' ? 'active' : ''}`}
            onClick={() => changeLanguage('ko')}
          >
            KR
          </button>
          <span className="lang-divider">|</span>
          <button
            type="button"
            className={`lang-button ${i18n.language === 'en' ? 'active' : ''}`}
            onClick={() => changeLanguage('en')}
          >
            EN
          </button>
        </div>
      </nav>

      {/* 모바일 햄버거 버튼 */}
      <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
        ☰
      </div>
    </header>
  );
}

export default NavBar;
